/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/jsx-no-literals */
// This page is used for the developers of the export API.
// It shows the JSON payload that is sent to the API when exporting a product.

import MainLayout from '@/components/layout/main/main.layout.component';
import { Product } from '@/gql/graphql';
import { useQuery } from '@apollo/client';
import ReactJson from '@microlink/react-json-view';
import { useParams } from 'react-router-dom';
import { getExportedProductVersion } from './export.page.requests';

export const ExportPage = () => {
  const { id } = useParams();

  const { data, loading } = useQuery<{ product: Product }>(getExportedProductVersion, {
    variables: { id },
  });
  return (
    <MainLayout>
      <h1 className="mb-4">Export API payload</h1>
      {loading && <p>Loading the export request...</p>}
      {data && (
        <ReactJson
          src={data}
          displayDataTypes={false}
          displayObjectSize={false}
          style={{
            fontSize: '1.4rem',
          }}
        />
      )}
    </MainLayout>
  );
};
